import { useDispatch } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { ReduxState } from 'reducers/index';

export const useAppDispatch = () : ThunkDispatch<ReduxState, any, AnyAction> => useDispatch();
export { useSelector } from 'react-redux';
